export default {
  BUTTON_PRIMARY_CLASS: 'button button--small',
  BUTTON_SECONDARY_CLASS: 'button button--secondary button--small',
  FACET_BUTTON_CLASS: 'cm_custom-button',
  PRODUCT_REPEATER_CLASS: 'productGrid',

  FACET_PANEL_CLASS: 'page-sidebar',
  MAIN_CONTENT_CLASS: 'page-content',

  AUTOCOMPLETE_PRODUCT_TITLE_CLASS: 'sidebarBlock-heading',

  SEARCH_BOX_PLACEHOLDER: 'How can we brighten your day?',
  SEARCH_BOX_FORM_CLASS: 'form',
  SEARCH_BOX_INPUT_CLASS: 'form-input',
  SEARCH_BOX_BUTTON_CLASS: 'form-button',
};
